import { isBaseQueryParams } from "@/helpers/isBaseQueryParams";
import { QueryParamsBase } from "@/types/types";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getProducts, getProductRecipe } from "./api";
import { Recipe } from "@/types/recipe";

const STALE_TIME_BASE = 1000 * 60 * 10; // 10 minutos

export function useProducts(
  params?: QueryParamsBase,
  select?: string[],
  options?: object,
) {
  const isBaseQuery = isBaseQueryParams(params);

  const paramsQuery = isBaseQuery
    ? { current: params?.current, pageSize: params?.pagination?.pageSize }
    : params;

  const query = useQuery({
    queryKey: ["products", { params: paramsQuery, select }],
    queryFn: () => getProducts({ ...paramsQuery, select }),
    staleTime: isBaseQuery ? STALE_TIME_BASE : 0,
    gcTime: isBaseQuery ? STALE_TIME_BASE : 0,
    placeholderData: keepPreviousData,
    ...options,
  });

  return { ...query };
}

export function useProductRecipe(productId: string, options?: object) {
  const query = useQuery<Recipe | null>({
    queryKey: ["productRecipe", productId],
    queryFn: () => getProductRecipe(productId),
    staleTime: 1000 * 60 * 2, // 2 minutes
    gcTime: 1000 * 60 * 2,
    enabled: !!productId,
    ...options,
  });

  return { ...query };
}

